import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ConversationCacheState {
  cache: Record<string, any[]>
  getCache: (conversationId: string) => any[] | undefined
  setCache: (conversationId: string, messages: any[]) => void
  removeConversation: (conversationId: string) => void
  clear: () => void
}

type ConversationCachePersisted = Pick<ConversationCacheState, 'cache'>

export const useConversationCacheStore = create<ConversationCacheState>()(
  persist(
    (set, get) => ({
      cache: {},
      getCache: (conversationId) => get().cache[conversationId],
      setCache: (conversationId, messages) =>
        set(state => ({
          cache: {
            ...state.cache,
            [conversationId]: messages
          }
        })),
      removeConversation: (conversationId) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [conversationId]: _, ...rest } = get().cache
      set({ cache: rest })
      },
      clear: () => set({ cache: {} })
    }),
    {
      name: 'conversation-cache',
      partialize: (state): ConversationCachePersisted => ({
        cache: state.cache
      })
    }
  )
)
